import { React, ts, useSelector } from '_core';

import Chart from './chart';

type PortfolioRiskFactorExposureProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  widgetPaths: Record<
    'backtest_factor_exposure_analysis' | 'rebalance_factor_exposure_analysis' | 'portfolio_factor_exposure_analysis',
    string
  >;
  title: string;
  fullScreen: boolean;
  context:
    | ts.types.portfolio.PortfolioAnalysisContext
    | ts.types.backtest.BacktestAnaylsisContext
    | ts.types.basket.BasketAnalysisContext;
};

const PortfolioRiskFactorExposure = ({
  id,
  readOnly,
  widgetKey,
  loadWidgetData,
  widgetPaths,
  fullScreen,
  title,
  context,
}: PortfolioRiskFactorExposureProps) => {
  const fileKey = React.useMemo(
    () =>
      Object.keys(widgetPaths || {}).find((k) => k.endsWith('_factor_exposure_analysis')) as keyof typeof widgetPaths,
    [widgetPaths]
  );

  const strategies = useSelector((state) => state.resources.strategies);

  const riskModels = useSelector((state) => state.resources.risk_models);

  const strategy = React.useMemo(() => {
    return strategies.find(
      (s) => s.id === (context as ts.types.portfolio.PortfolioAnalysisContext).definition.strategy_id
    );
  }, [strategies, context]);

  const riskModelId = React.useMemo(() => {
    if (strategy) return strategy.definition.risk_model_id;
    return (context as ts.types.basket.BasketAnalysisContext | ts.types.backtest.BacktestAnaylsisContext).definition
      .risk_model_id;
  }, [strategy, context]);

  const riskModel = React.useMemo(() => {
    return riskModels.find((rm) => rm.id === riskModelId);
  }, [riskModels, riskModelId]);

  return (
    <>
      <Chart
        id={id}
        readOnly={readOnly}
        widgetKey={widgetKey}
        loadWidgetData={loadWidgetData}
        file={widgetPaths[fileKey]}
        fullScreen={fullScreen}
        riskModel={riskModel}
        title={title}
      />
    </>
  );
};

export default PortfolioRiskFactorExposure;
